import React, { useEffect, useState } from 'react';

import { sample } from 'lodash';

import { colors } from 'theme/palette';

import Typography from 'components/Typography';

import styles from './styles.module.scss';

const tips = [
  "Students benefit most from exemplars that show both the 'what' and the 'why'.",
  "Modeling a high-quality answer builds students' confidence to try their own.",
  'Use exemplar-based feedback to help students internalize success criteria.',
  "Exemplars help shift the focus from 'right or wrong' to 'how to grow'.",
  'Check the transcription before assigning — a quick edit ensures students see exactly what you intend.',
  'Use EdLight to track progress over time — patterns across student work help guide instruction.',
  'Tag standards as you assign — it powers the insights EdLight gives you later.',
  'After grading, review the insights tab — it surfaces common trends and student misconceptions.',
  'Save time by reusing assignments — duplicate and adjust past tasks instead of starting from scratch.'
];

const EdlightTip = () => {
  const [tip, setTip] = useState(0);

  useEffect(() => {
    setTip(sample(tips));
  }, []);

  return (
    <Typography
      variant={'B-Text-3'}
      className={styles.subText}
      color={colors.grey2}
    >
      EdLight Tip: {tip}
    </Typography>
  );
};

export default EdlightTip;
